import { Box, Collapse, TableCell } from '@/shared/ui';

import SymbolsPreview from '@/features/_shared/SymbolsPreview';

import type { MultiGroupTableRowType } from '@/features/markets/types';

const CollapsedRow = ({
  open,
  row,
  colSpan
}: {
  open: boolean;
  row: MultiGroupTableRowType;
  colSpan: number;
}) => {
  return (
    <TableCell
      className='collapsed-table-row'
      colSpan={colSpan}
      sx={theme => ({
        pb: 0,
        pt: 0,
        borderLeft: `2px solid ${open ? theme.palette.gx.highlight : 'transparent'}`
      })}
    >
      <Collapse
        in={open}
        timeout='auto'
      >
        <Box sx={{ ml: 3.5 }}>
          <SymbolsPreview
            hideInfo
            enableQuery={open}
            stickyHeader={false}
            items={[
              {
                symbol: row.symbolA.key,
                label: 'Last',
                metadata: row.symbolAMetadata ?? undefined,
                periodAbs: row.periodAbs
              }
            ]}
          />
        </Box>
      </Collapse>
    </TableCell>
  );
};

export default CollapsedRow;
